import { EffectCallback, useEffect } from 'react';

const useComponentDidMount = (effect: EffectCallback) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect, []);
};

export default useComponentDidMount;
